module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-vehicle-category"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Name"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.name),
      expression: "body.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.body.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "name", $event.target.value)
      }
    }
  })]), _c('label', [_vm._v("Description"), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.description),
      expression: "body.description"
    }],
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.body.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "description", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Vehicle Types"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.vehicle_type_id),
      expression: "body.vehicle_type_id"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body, "vehicle_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.vehicleTypes), function(vehicleType) {
    return _c('option', {
      domProps: {
        "value": vehicleType.id
      }
    }, [_vm._v(_vm._s(vehicleType.name))])
  }), 0)]), _c('label', [_vm._v("Category image")]), _c('KeplerFileUpload', {
    attrs: {
      "selected-prefix": "vehicle-categories",
      "selected-visibility": "public",
      "previewUrl": _vm.body.picture
    },
    on: {
      "sel": _vm.handleFileSelector
    }
  }), _c('label', [_vm._v("Category damage picture")]), _c('KeplerFileUpload', {
    attrs: {
      "selected-prefix": "damage-picture",
      "selected-visibility": "public",
      "previewUrl": _vm.body.damage_picture
    },
    on: {
      "sel": _vm.handleFileDamageSelector
    }
  })], 1)]), _c('div', {
    staticClass: "row column"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.addVehicleCategory
    }
  }, [_vm._v("Create")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dab1061e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/CreateVehicleCategory.vue
// module id = 2703
// module chunks = 1